import {
  Card,
  Paper,
  TextField,
  MenuItem,
  Typography,
  Checkbox,
  Divider,
  Grid,
  useTheme,
} from '@mui/material';
import React, { FC, useState } from 'react';
import { CheckedItemsState } from '../Model/AzureDevOpsModel';
import { azureDevOpsService } from '../AzureDevOpsService';
import { farmService } from '../../Farm/FarmService';
import { Farm } from '../../Farm/Model/FarmModel';
import {
  GlobalComponent,
  ReleaseRequest,
} from '../../ManageFarms/Model/FarmModel';
import {
  DeploymentFooter,
  DeploymentTypeComponent,
  GlobalDeploymentComponent,
} from '../Common/CommonMethod';
import { useHistory } from 'react-router-dom';
import { Loader } from '../../../../Common/Components/Loader';
import { BranchCardProps, BranchSelectorProps } from './DeploymentProps';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';

export default function DeployGlobalComponents() {
  const history = useHistory();
  const { t } = useTranslation('azuredevops');
  const initialfarms: Farm[] = [];
  const [farms, setFarms] = useState(initialfarms);
  const [checkedItems, setCheckedItems] = useState<CheckedItemsState>({});
  const [branches, setbranches] = useState<string[]>([]);
  const [selectedBranch, setSelectedBranch] = useState('refs/heads/master');
  const [selectedDtsBranch, setSelectedDtsBranch] =
    useState('refs/heads/master');
  const [dtsBranches, setDTSBranches] = useState<string[]>([]);
  const [commonresources, setCommonResources] = useState(false);
  const [formatconverter, setFormatConverter] = useState(false);
  const [azureFrontDoor, setAzureFrontDoor] = useState(false);
  const [webviewer, setWebviewer] = useState(false);
  const [indexingsearch, setIndexingSearch] = useState(false);
  const [monitoring, setMonitoring] = useState(false);
  const [disasterrecovery, setDisasterrecovery] = useState(false);
  const [rollback, setRollback] = useState(false);
  const [DeployOnly, setDeployOnly] = useState(false);
  const [DeployDTS, setDeployDTS] = useState(false);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    loadInitData();
  }, []);

  const loadInitData = async () => {
    await loadDtsBuilds();
    await loadBranches();
    await loadFarms();
  };

  const theme = useTheme();
  const loadDtsBuilds = async () => {
    try {
      setLoading(true);
      const dtsbranches = await azureDevOpsService.getDtsBranches();
      setDTSBranches(dtsbranches.Items);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const loadBranches = async () => {
    try {
      const response = await azureDevOpsService.getProarcSetupBranches();
      const branchItems = Array.isArray(response)
        ? response
        : response?.Items ?? [];
      setbranches(branchItems);
    } catch (error) {
      console.log(error);
    }
  };

  const loadFarms = async () => {
    try {
      const farmsdata = await farmService.getFarms();
      const farms = farmsdata.Items.filter(function (e) {
        return e.Type === 'ProArc Online';
      });
      setFarms(farms);
    } catch (error) {
      console.log(error);
    }
  };

  function handleCheckbox(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.name === 'FarmatConverter') {
      setFormatConverter(event.target.checked);
    } else if (event.target.name === 'DTS') {
      setDeployDTS(event.target.checked);
    }
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  function handleFieldChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    if (name === 'SelectedBranch') {
      setSelectedBranch(value);
    } else if (name === 'SelectedDtsBuild') {
      setSelectedDtsBranch(value);
    }
  }

  function getUniqueFarmsByRegion(
    farms: Farm[],
    selectedFarmIds: number[],
  ): Farm[] {
    const selectedFarms = farms.filter((farm) =>
      selectedFarmIds.includes(farm.Id),
    );
    const uniqueFarmsByRegion: { [key: string]: Farm } = {};

    selectedFarms.forEach((farm) => {
      if (
        !uniqueFarmsByRegion[
          disasterrecovery ? farm.SecondaryRegion : farm.FarmRegion
        ]
      ) {
        uniqueFarmsByRegion[
          disasterrecovery ? farm.SecondaryRegion : farm.FarmRegion
        ] = farm;
      }
    });

    return Object.values(uniqueFarmsByRegion);
  }

  const RenderCheckbox = (props: {
    name: string;
    checked: boolean;
    label: string;
    handler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  }) => {
    return (
      <div
        style={{
          display: 'block',
          marginRight: '20px',
        }}
      >
        <Checkbox
          checked={props.checked}
          color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
          name={props.name}
          onChange={props.handler}
        />
        <label>{props.label}</label>
      </div>
    );
  };

  const DeployGlobalService = async () => {
    await deployGlobalComponent();
    await deployDTS();

    async function deployDTS() {
      const release: ReleaseRequest = {};
      if (DeployDTS) {
        release.deployDTS = DeployDTS;
        release.dtsBranch = selectedDtsBranch;
        await CreateRelease(release);
      }
    }

    async function deployGlobalComponent() {
      const release: ReleaseRequest = {};

      release.rollback = rollback;
      release.disasterRecovery = disasterrecovery;
      release.branch = selectedBranch;

      let farmids: number[] = [];

      const getSelectedFarmIds = (): number[] => {
        return Object.keys(checkedItems)
          .filter((key) => checkedItems[key])
          .map(Number);
      };

      const handleCommonResources = async () => {
        release.GlobalComponent = GlobalComponent.COMMON;
        farmids = getSelectedFarmIds();
        if (farmids.length < 1) {
          showToast({
            type: 'info',
            title: t('azuredevops.info.common_resources'),
          });
          return;
        }
        const uniqueFarmsByRegion = getUniqueFarmsByRegion(farms, farmids);
        for (const farm of uniqueFarmsByRegion) {
          await CreateRelease({ ...release, farmId: farm.Id });
        }
      };

      const handleIndexingSearch = async () => {
        release.GlobalComponent = GlobalComponent.INDEXINGSEARCH;
        farmids = getSelectedFarmIds();
        if (farmids.length < 1) {
          showToast({
            type: 'info',
            title: t('azuredevops.info.indexing'),
          });
          return;
        }
        for (const farmId of farmids) {
          await CreateRelease({ ...release, farmId });
        }
      };

      const handleMonitoring = async () => {
        release.GlobalComponent = GlobalComponent.MONITORING;
        farmids = getSelectedFarmIds();
        if (farmids.length < 1) {
          showToast({
            type: 'info',
            title: t('azuredevops.info.monitoring'),
          });
          return;
        }
        for (const farmId of farmids) {
          await CreateRelease({ ...release, farmId });
        }
      };

      switch (true) {
        case commonresources:
          await handleCommonResources();
          break;
        case webviewer:
          release.GlobalComponent = GlobalComponent.WEBVIEW;
          await CreateRelease(release);
          break;
        case formatconverter:
          release.GlobalComponent = GlobalComponent.FORMATCONVERTER;
          await CreateRelease(release);
          break;
        case azureFrontDoor:
          release.GlobalComponent = GlobalComponent.AZUREFRONTDOOR;
          await CreateRelease(release);
          break;
        case indexingsearch:
          await handleIndexingSearch();
          break;
        case monitoring:
          await handleMonitoring();
          break;
        default:
          if (!DeployDTS) {
            showToast({
              type: 'info',
              title: t('azuredevops.info.default'),
            });
          }
          return;
      }
    }
  };

  const CreateRelease = async (Release: ReleaseRequest) => {
    try {
      azureDevOpsService.CreateRelease(Release);
      showToast({
        type: 'success',
        title: t('azuredevops.success.queued'),
      });
      history.push('/farm');
    } catch (error) {
      showToast({
        type: 'error',
        title: t('azuredevops.error.queued'),
      });
      console.log(error);
    }
  };

  const DtsBranchSelector: FC<BranchSelectorProps> = ({
    branches,
    selectedBranch,
    handleFieldChange,
  }) => (
    <Grid container spacing={2} alignItems="center" mt={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="body1">Dts Branch</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={selectedBranch}
          placeholder="Dts build"
          name="SelectedDtsBuild"
          onChange={handleFieldChange}
          select
          variant="outlined"
          size="small"
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 350,
                  overflow: 'auto',
                  maxwidth: 300,
                },
              },
            },
          }}
        >
          {branches.map((branch) => (
            <MenuItem key={branch} value={branch}>
              {branch}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );

  const PlatformBranchSelector: FC<BranchSelectorProps> = ({
    branches,
    selectedBranch,
    handleFieldChange,
  }) => (
    <Grid container spacing={2} alignItems="center" mt={2}>
      <Grid item xs={12} sm={6}>
        <Typography variant="body1">Platform Branch</Typography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          value={selectedBranch}
          name="SelectedBranch"
          onChange={handleFieldChange}
          select
          variant="outlined"
          size="small"
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  maxHeight: 350,
                  overflowY: 'auto',
                  maxWidth: 300,
                },
              },
            },
          }}
        >
          {branches.map((branch) => (
            <MenuItem key={branch} value={branch}>
              {branch}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );

  const BranchCard: FC<BranchCardProps> = ({
    dtsBranches,
    branches,
    selectedDtsBranch,
    selectedBranch,
    handleFieldChange,
  }) => (
    <Card
      elevation={3}
      sx={{
        p: 3,
        borderRadius: '12px',
        bgcolor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[3],
      }}
    >
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Branches
      </Typography>
      <Divider sx={{ mb: 3 }} />
      {dtsBranches && DeployDTS && (
        <DtsBranchSelector
          branches={dtsBranches}
          selectedBranch={selectedDtsBranch}
          handleFieldChange={handleFieldChange}
        />
      )}
      {branches &&
        (webviewer ||
          indexingsearch ||
          azureFrontDoor ||
          formatconverter ||
          monitoring ||
          commonresources) && (
          <PlatformBranchSelector
            branches={branches}
            selectedBranch={selectedBranch}
            handleFieldChange={handleFieldChange}
          />
        )}
    </Card>
  );

  return (
    <div>
      <Loader loading={loading} />
      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          boxShadow: 3,
          maxWidth: '100%',
          mx: 'auto',
        }}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          Deployment Center
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: '12px',
                bgcolor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                boxShadow: theme.shadows[3],
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Global Services
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <>
                <GlobalDeploymentComponent
                  commonresources={commonresources}
                  webviewer={webviewer}
                  AZUREFRONTDOOR={azureFrontDoor}
                  formatconverter={formatconverter}
                  indexingsearch={indexingsearch}
                  monitoring={monitoring}
                  handleCheckbox={handleCheckbox}
                  setCommonResources={setCommonResources}
                  setFormatConverter={setFormatConverter}
                  setAZUREFRONTDOOR={setAzureFrontDoor}
                  setWebViewer={setWebviewer}
                  setIndexingSearch={setIndexingSearch}
                  setMonitoring={setMonitoring}
                />
                {!commonresources && (
                  <RenderCheckbox
                    checked={DeployDTS}
                    label="DTS"
                    name="DTS"
                    key="DTS"
                    handler={handleCheckbox}
                  />
                )}
              </>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Card
              elevation={3}
              sx={{
                p: 3,
                borderRadius: '12px',
                bgcolor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                boxShadow: theme.shadows[3],
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Deployment Type (Leave empty for default)
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <DeploymentTypeComponent
                disasterrecovery={disasterrecovery}
                rollback={rollback}
                DeployOnly={DeployOnly}
                handleCheckbox={handleCheckbox}
                setDeployOnly={setDeployOnly}
                setRollback={setRollback}
                setDisasterrecovery={setDisasterrecovery}
                displayOptions={{
                  deployOnly: false,
                  rollback: true,
                  disasterRecovery: true,
                }}
              />
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            {(commonresources ||
              webviewer ||
              indexingsearch ||
              azureFrontDoor ||
              formatconverter ||
              monitoring ||
              DeployDTS) && (
              <BranchCard
                branches={branches}
                dtsBranches={dtsBranches}
                handleFieldChange={handleFieldChange}
                selectedBranch={selectedBranch}
                selectedDtsBranch={selectedDtsBranch}
              />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            {(indexingsearch || commonresources || monitoring) && (
              <Card
                elevation={3}
                sx={{
                  p: 3,
                  borderRadius: '12px',
                  bgcolor: theme.palette.background.paper,
                  color: theme.palette.text.primary,
                  boxShadow: theme.shadows[3],
                }}
              >
                <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                  Farms
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <>
                  {farms.map((farm) => (
                    <RenderCheckbox
                      name={farm.Id.toString()}
                      checked={checkedItems[farm.Id]}
                      label={`${farm.Id} - ${farm.DisplayName}`}
                      key={farm.Id}
                      handler={handleCheckboxChange}
                    />
                  ))}
                </>
              </Card>
            )}
          </Grid>
        </Grid>
        <DeploymentFooter DeployAppServices={DeployGlobalService} />
      </Paper>
    </div>
  );
}
